import { FeatureFlagKeyEnum } from './FeatureFlagKeyEnum'
import { CustomerLayoutChoiceEnum, CustomerLayoutChoiceMetadata } from './choices/CustomerLayoutChoice'

export interface FeatureFlagChoiceConfig<T extends string = string> {
  choices: readonly T[]
  defaultChoice: T
  metadata: Record<T, { name: string; description: string }>
}

export const FeatureFlagChoiceMapping: Record<FeatureFlagKeyEnum, FeatureFlagChoiceConfig> = {
  [FeatureFlagKeyEnum.CUSTOMER_LAYOUT]: {
    choices: Object.values(CustomerLayoutChoiceEnum),
    defaultChoice: CustomerLayoutChoiceEnum.TREE,
    metadata: CustomerLayoutChoiceMetadata,
  },
}
